// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

export    const firebaseConfig = {
  apiKey: "AIzaSyA-fzujPCa2hPGcIapQkRtqQhC3BwDXiF8",
  authDomain: "festum-gsr.firebaseapp.com",
  databaseURL: "https://festum-gsr-default-rtdb.firebaseio.com",
  projectId: "festum-gsr",
  storageBucket: "festum-gsr.appspot.com",
  messagingSenderId: "10751453196",
  appId: "1:10751453196:web:b21e03d8e77c0952296629",
  measurementId: "G-14VELZL5SW"
}; 


export const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
